import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTrunkType } from 'API/TrunkTypes/createTrunkType';

const useCreateTrunkType = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const create = async (trunkTypeData) => {
        const response = await createTrunkType(trunkTypeData);
        return response.data;
    };

    return useMutation({
        mutationFn: create,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['TrunkTypes'] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateTrunkType;
